import type { PartyMember, PartyRequest } from "./members.ts";
import type { RefusalContext } from "./refusal-words.ts";

/**
 * The words of a request for a refusal's context.
 *
 * @param request The request.
 * @returns The context's request word.
 */
export function contextOf(request: PartyRequest): NonNullable<RefusalContext["request"]> {
  switch (request.kind) {
    case "partyInvite":
      return "invite";
    case "partyAnswer":
      return "answer";
    case "partyLeave":
      return "leave";
    case "partyRemove":
      return "remove";
    case "partyPromote":
      return "promote";
    case "partyGrant":
      return "grant";
  }
}

/**
 * Whether two rosters hold the same seats, so a roster sent again unchanged is not a change.
 *
 * @param a One roster, in place order.
 * @param b The other.
 * @returns True when every seat is equal.
 */
export function sameRoster(a: readonly PartyMember[], b: readonly PartyMember[]): boolean {
  return a.length === b.length && a.every((seat, index) => {
    const other = b[index] as PartyMember;
    return seat.place === other.place && seat.firstName === other.firstName && seat.familyName === other.familyName && seat.leader === other.leader && seat.mayInvite === other.mayInvite && seat.online === other.online && seat.map === other.map;
  });
}
